import React from 'react';

export default function AssignmentTypeTable({ assignmentTypes, onEdit, onToggleStatus }) {
  if (!assignmentTypes.length) {
    return (
      <div className="bg-white rounded shadow p-8 text-center text-gray-500">
        No assignment types are configured. Use “Initialize Defaults” or add a type manually.
      </div>
    );
  }

  return (
    <div className="bg-white rounded shadow overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100 text-left">
          <tr>
            <th className="px-4 py-3">Order</th>
            <th className="px-4 py-3">Assignment Type</th>
            <th className="px-4 py-3">Requires Matter</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {assignmentTypes.map((item) => (
            <tr key={item.id} className="border-t hover:bg-gray-50">
              <td className="px-4 py-3 text-gray-500">{Number(item.sortOrder) || 0}</td>
              <td className="px-4 py-3 font-medium">{item.name || '—'}</td>
              <td className="px-4 py-3">
                <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${item.requiresMatter ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-600'}`}>
                  {item.requiresMatter ? 'Yes' : 'No'}
                </span>
              </td>
              <td className="px-4 py-3">
                <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${item.isActive !== false ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                  {item.isActive !== false ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td className="px-4 py-3 text-right whitespace-nowrap">
                <button onClick={() => onEdit(item)} className="rounded bg-blue-900 px-3 py-1 font-medium text-white hover:bg-blue-800">Edit</button>
                <button
                  onClick={() => onToggleStatus(item)}
                  className={`ml-2 rounded px-3 py-1 font-medium text-white ${item.isActive !== false ? 'bg-red-600 hover:bg-red-700' : 'bg-green-700 hover:bg-green-800'}`}
                >
                  {item.isActive !== false ? 'Deactivate' : 'Activate'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
